export default __webpack_public_path__ + "static/media/Aashika.b3bed3d5.JPG";